import store from '@/store/store'
import router from '@/router'

/**
 * Checks for a 401 Unauthorized response from the API, and if found, displays an error message and prompts
 * the user to reauthenticate
 */
export default {
  install (Vue) {
    Vue.http.interceptors.push((request, next) => {
      next((response) => {
        if (response && String(response.status) === '401') {
          store.dispatch('setReauthRequired', true)
          store.dispatch('setPostAuthorizationRoute', router.history.current.name)
          store.dispatch('changeModalVisibility', { entityType: 'reauthModal', visible: true })
          if (!Vue.prototype.$unauthorizedNotif) {
            Vue.prototype.$unauthorizedNotif = Vue.prototype.$notify
            Vue.prototype.$unauthorizedNotif.error({
              title: 'Session expired',
              message: 'Please log in again.',
              duration: 10000
            })
            setTimeout(() => {
              Vue.prototype.$unauthorizedNotif = null
            }, 10000)
          }
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/interceptors/unauthorized_request.js